import type { ShowRoomPlanEventData } from "@/data/model/Table";
import { Signal, TypedSignal } from "@/data/util/Signal";



import { BaseController } from "@/app/controller/BaseController";


export class RoomPlanController extends BaseController {
    public onContinue?: { () };
    public onShowServices?: { () };

    static onInit = new Signal();
    static onShown = new TypedSignal<ShowRoomPlanEventData | undefined>();
    static onHidden = new Signal();

    static onContinue = new Signal();
    static onShowServices = new Signal();

    constructor() {
        super("room-plan");

        RoomPlanController.onContinue.add(this.continue, this);
        RoomPlanController.onShowServices.add(this.showServices, this);

        RoomPlanController.onInit.dispatch();
    }

    protected onBecomeVisible(param?: ShowRoomPlanEventData) {
        RoomPlanController.onShown.dispatch(param);
    }

    protected onBecomeInvisible() {
        RoomPlanController.onHidden.dispatch();
    }

    protected showServices() {
        if (this.onShowServices) {
            this.onShowServices();
        }
    }

    protected continue() {
        if (this.onContinue) {
            this.onContinue();
        }
    }
}
